import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../../config/axiosConfig";

export const createHealthCard = async ({
  name,
  price,
  benefits,
  duration,
  status,
}) => {
  const payload = {
    card_name: name,
    price,
    duration_in_months: duration,
    benefits,
    status,
  };
  try {
    const res = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "card-masters/admin/create",
      data: payload,
    });

    if (res?.status === 201 || res?.status === 200 || res?.status === true) {
      return {
        success: true,
        data: res,
        message: "Card created Successfully!",
      };
    } else {
      return {
        success: false,
        data: res,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid card creation attempt.",
    };
  }
};
export const updateHealthCard = async ({
  name,
  price,
  benefits,
  duration,
  status,
  cardId,
}) => {
  const payload = {
    price,
    duration_in_months: duration,
    status,
    benefits,
    card_name: name,
  };
  try {
    const res = await putRequest({
      url:
        process.env.REACT_APP_BASE_URL + `card-masters/admin/update/${cardId}`,
      data: payload,
    });

    if (res?.status === 200 || res?.status === true) {
      return {
        success: true,
        data: res,
        message: "Card updated Successfully!",
      };
    } else {
      return {
        success: false,
        data: res,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid card update attempt.",
    };
  }
};
export const getHealthCard = async ({page}) => {
  try {
    const res = await getRequest({
      url:
        process.env.REACT_APP_BASE_URL +
        `card-masters/admin/get-all?limit=5&page=${page}`,
    });

    if (res?.status === 201 || res?.status === 200 || res?.status === true) {
      return {
        success: true,
        data: res,
        message: "Card get Successfully!",
      };
    } else {
      return {
        success: false,
        data: res,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid card getting attempt.",
    };
  }
};
export const deleteHealthCard = async ({ cardId }) => {
  try {
    const res = await deleteRequest({
      url:
        process.env.REACT_APP_BASE_URL +
        `card-masters/admin/delete/${cardId}`,
    });

    if (res?.status === 201 || res?.status === 200 || res?.status === true) {
      return {
        success: true,
        data: res,
        message: "Card deleted Successfully!",
      };
    } else {
      return {
        success: false,
        data: res,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid card delete attempt.",
    };
  }
};
